import { cn } from '@/lib/utils'

type Props = {
  className?: string
  type: 'blizzard' | 'wcl' | 'raiderio'
  backendUrl?: string
  realmName?: string
  region?: string
  entityName?: string
}

const CharacterExternalIconLink = ({
  className,
  type,
  backendUrl,
  realmName,
  region,
  entityName,
}: Props) => {
  const uriLinkFragment = `${region?.toLowerCase()}/${realmName?.toLowerCase()}/${entityName?.toLowerCase()}`

  const logoUrl = {
    blizzard: 'https://data.wowaudit.com/img/wow-logo.png',
    wcl: 'https://data.wowaudit.com/img/wcl-logo.png',
    raiderio: 'https://data.wowaudit.com/img/raiderio-logo.png',
  }[type]

  const href = {
    blizzard: backendUrl,
    wcl:
      backendUrl || `https://www.warcraftlogs.com/character/${uriLinkFragment}`,
    raiderio: backendUrl || `https://raider.io/characters/${uriLinkFragment}`,
  }[type]

  const alt = {
    blizzard: 'Blizzard',
    wcl: 'Warcraft Logs',
    raiderio: 'Raider.io',
  }

  const disabled =
    type === 'blizzard'
      ? !backendUrl
      : !backendUrl && (!realmName || !region || !entityName)

  return (
    <a
      href={disabled ? '#' : href}
      onClick={(e) => (disabled ? e.preventDefault() : e.stopPropagation())}
      className={disabled ? 'opacity-20 cursor-not-allowed grayscale' : ''}
      target={disabled ? undefined : '_blank'}
      rel='noreferrer'
      title={alt[type]}
    >
      <img
        src={logoUrl}
        className={cn('w-6 min-w-6', className ?? '')}
        alt={alt[type]}
      />
    </a>
  )
}

export default CharacterExternalIconLink
